import { Component, OnInit } from "@angular/core";
import { NewFlyerComponent } from "../new-flyer/new-flyer.component";
import { select, Store } from "@ngrx/store";
import { selectActiveNewModal } from "src/app/state/interface/interface.selector";
import { EntityType } from "src/app/state/entities/entity.model";
import { interfaceActions } from "src/app/state/interface/interface.actions";

import {
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
} from "angular-animations";
import { NewImageComponent } from "../new-image/new-image.component";

@Component({
  selector: "binsta-new-holder",
  standalone: true,
  imports: [NewFlyerComponent, NewImageComponent],
  templateUrl: "./new-holder.component.html",
  styleUrl: "./new-holder.component.scss",
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()],
})
export class NewHolderComponent implements OnInit {
  activeComponent: EntityType = null;
  entities = EntityType;
  closed = false;

  constructor(private store: Store) {}

  async ngOnInit(): Promise<void> {
    this.entities = EntityType;
    this.store.select(selectActiveNewModal).subscribe((kind) => {
      this.activeComponent = kind;
    });
    // this.store.dispatch(
    //   interfaceActions.showNewModal({ kind: EntityType.Image }),
    // );
  }

  closeHolder() {
    this.store.dispatch(interfaceActions.showNewModal({ kind: null }));
  }

  open(kind: EntityType) {
    this.store.dispatch(interfaceActions.showNewModal({ kind }));
  }
}
